import { ElementRef } from '@angular/core';
import { FormGroup } from '@angular/forms';

/**
 * Validate if a control has any error.
 * @param name Form control name.
 * @param form Form instance.
 * @returns Flag to know if a control has any error.
 */
export const isValidControl = (name: string, form: FormGroup): boolean => {
  const control = form.controls[name];
  return (control && control.errors && control.touched) ?? false;
};

/**
 * Focus on control with error.
 * @param form Form instance.
 * @param element Element reference instance.
 */
export const focusOnInvalidControl = (form: FormGroup, element: ElementRef): void => {
  for (const key of Object.keys(form.controls)) {
    if (form.controls[key].invalid) {
      const invalidControl = element.nativeElement.querySelector('[formcontrolname="' + key + '"]');
      invalidControl.focus();
      break;
    }
  }
};